import React, { Component } from 'react'
import { get, snakeCase } from 'lodash'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Title, CircleBadge } from 'components/misc'
import { Summary, ElevatedButton } from 'components/layout'
import { ACTIVITY_SECTIONS } from 'constants/enums'
import {
  apiAwards,
  apiAdventurousJourney
} from 'helpers/decorators/api/dashboard'
import { downloadLink } from 'helpers/decorators'
import { createGroupActivities } from 'helpers/selectors'
import { getActivityClassName, getActivityIconName } from 'helpers/dashboard'
import styles from '../AwardSummary/award-summary.styl'
import PropTypes from 'prop-types'


const DownloadButton = downloadLink(ElevatedButton)
const groupActivities = createGroupActivities()

const titleStyle = { float: 'left', marginRight: 10 }

@apiAwards()
@apiAdventurousJourney()
@injectIntl
class AwardSummary extends Component {
  static propTypes = {
    awards: PropTypes.object.isRequired,
    aJValues: PropTypes.object,
    intl: PropTypes.func,
    onGetAwardDetail: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.props.onGetAwardDetail(this.props.params.awardId)
  }


  getDigitalBadgeUrl = (award, intl) => {

    const digitalBadgeUrl = get(award, 'digitalBadgeUrl')

    if(digitalBadgeUrl){

      const btnTertiaryDisplayDigitalBadge = intl.formatMessage({
        id: 'btn.display_digital_badge',
        defaultMessage: 'Display Digital Badge'
      })

      return (
        <a className={styles.downloadLink} href={digitalBadgeUrl} ><div className={styles.downloadLinkWrapper}>
        {btnTertiaryDisplayDigitalBadge}
        </div>
        </a>
          )

    } else {
      return null
    }


  }

  render() {
    const { awards, aJValues, intl } = this.props
    const data = get(awards, 'data', {})
    const activities = get(awards, 'activities', [])

    const groupedActivities = groupActivities(activities)
    const btnDownloadSection = intl.formatMessage({
      id: 'btn.download_summary_for_assessor',
      defaultMessage: 'Download summary for assessor'
    })

    const btnDownloadAward = intl.formatMessage({
      id: 'btn.download_award_detail_summary',
      defaultMessage: 'Download award detail'
    })

    const btnSecondaryDownloadAward = intl.formatMessage({
      id: 'btn.download_award_summary',
      defaultMessage: 'Download award summary'
    })

    const aj = get(aJValues, 'data')

    const rp = get(data, 'residentialProject')

    return (
      <Summary.Wrap>
        <Summary.Header
          startDate={get(data, 'startDate')}
          endDate={get(data, 'officeSignoffDate')}
          downloadButton={
            <DownloadButton
              url={`/awards/${get(data, 'id')}/award-detail-report-generation`}
              secondary
              link
            >
              {btnDownloadAward}
            </DownloadButton>
          }
          secondaryDownloadButton={
            <DownloadButton
              url={`/awards/${get(data, 'id')}/summary-report-generation`}
              secondary
              link
            >
              {btnSecondaryDownloadAward}
            </DownloadButton>
          }
          tertiaryDownloadButton={this.getDigitalBadgeUrl(data, intl)}
        />

        {groupedActivities &&
          Object.keys(groupedActivities).map(section => {
            const sectionKey = Object.keys(ACTIVITY_SECTIONS).find(
              key => ACTIVITY_SECTIONS[key].id === section
            )
            const sectionObj = get(ACTIVITY_SECTIONS, `[${sectionKey}]`)
            const colorClass = getActivityClassName(section)
            const firstActivity = get(groupedActivities[section], '[0]', {})

            return (
              <Summary.Section className="row" key={section}>
                <div className="col-xs-12">
                  <Title colorClass={colorClass} h3 bold>
                    <CircleBadge
                      colorClass={colorClass}
                      style={titleStyle}
                      small
                    >
                      {getActivityIconName(sectionObj.id)}
                    </CircleBadge>
                    <FormattedMessage
                      id={`label.${snakeCase(sectionObj.id)}`}
                      defaultMessage={sectionObj.label}
                    />
                  </Title>

                  <Summary.SectionTable activity={firstActivity} />

                  {groupedActivities[section].map((activity, index) => (
                    <Summary.SectionOverview
                      activity={activity}
                      colorClass={colorClass}
                      index={index}
                      key={activity.id}
                      section={section}
                    />
                  ))}
                </div>
                <div className="col-xs-12">
                  <DownloadButton
                    url={`/activities/${get(
                      groupedActivities[section],
                      '[0].id'
                    )}/summary-report-generation`}
                    secondary
                    link
                  >
                    {btnDownloadSection}
                  </DownloadButton>
                </div>
              </Summary.Section>
            )
          })}

        {get(aj, 'adventurousJourneys[0].id') && (
          <Summary.Section>
            <Summary.AJOverview
              aj={aj}
              downloadButton={
                <DownloadButton
                  url={`/aj-participant-events/${get(
                    aj,
                    'adventurousJourneys[0].id'
                  )}/summary-report-generation`}
                  secondary
                  link
                >
                  {btnDownloadSection}
                </DownloadButton>
              }
            />
          </Summary.Section>
        )}

        {get(rp, 'id') && (
          <Summary.Section>
            <Summary.RPOverview
              rp={rp}
              downloadButton={
                <DownloadButton
                  url={`/residential-projects/${
                    rp.id
                  }/summary-report-generation`}
                  secondary
                  link
                >
                  {btnDownloadSection}
                </DownloadButton>
              }
            />
          </Summary.Section>
        )}
      </Summary.Wrap>
    )
  }
}

export default AwardSummary
